<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row align-items-center mb-1">
        <div class="col-md-6">
          <div class="h2">Parent Corporation Details</div>
        </div>
        <div class="col-md-2 offset-md-4 text-right center">
          <button type="submit" class="btn btn-warning btn-fill" @click="editParentCorp">Edit Parent Corporation</button>
        </div>
      </div>
      <div class="table-responsive" v-if="parentCorp">
        <table class="table table-bordered table-light">
          <tr>
            <th>Id</th>
            <td>{{parentCorp.parentAccountId}}</td>
          </tr>
          <tr>
            <th>Parent Corporation Name/Title</th>
            <td>{{parentCorp.name}}</td>
          </tr>
          <tr>
            <th>Description</th>
            <td>{{parentCorp.description}}</td>
          </tr>
          <tr>
            <th>Child Corporations</th>
            <td>{{parentCorp.csvCorporationNames}}</td>
          </tr>
          <tr>
            <th>Parent Super Users</th>
            <td>{{parentCorp.csvParentSuperUserNames}}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td v-if="parentCorp.active == '0'">Inactive</td>
            <td v-else>Active</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/UIComponents/Table.vue'
  import { mapGetters } from 'vuex'
  export default {
    name: 'ViewParentCorp',
    components: {
      LTable,
    },
    created (){
      this.$store.dispatch('GET_SELECTED_PARENT_CORP', this.$route.params.id).then(() =>{
        console.log('selected', this.selectedParentCorp)
        this.parentCorp = this.selectedParentCorp;
      })
    },
    data () {
      return {
        parentCorp: {}
      }
    },
    methods: {
      editParentCorp(){
        this.$router.push({ name: 'Edit Parent Corporation', params: { id: this.parentCorp.parentAccountId}})
      },
    },
    computed: {...mapGetters([
      'selectedParentCorp'])
    }
  }
</script>

<style>
  th{
    width: 180px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ParentCorps/ParentCorpDetails.vue